<template>
  <v-container>
    <v-form ref="form" id="publication-contact-form">
      <validation-observer ref="validationObserver" v-slot="{ invalid }">
        <v-row class="hidden-lg-and-up mb-n8">
          <v-col>
            <v-select
              :label="$t('form.fields.salutation.label')"
              outlined
              v-model="user.salutation"
              :items="genderTypes"
              :error-messages="errors"
            ></v-select>
          </v-col>
          <v-col>
            <v-text-field outlined v-model="user.title" :label="$t('form.fields.title')"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="2" class="hidden-md-and-down">
            <v-select
              :label="$t('form.fields.salutation.label')"
              outlined
              v-model="user.salutation"
              :items="genderTypes"
            ></v-select>
          </v-col>
          <v-col>
            <validation-provider :name="$t('form.fields.firstname')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.firstname') + ' *'"
                outlined
                v-model="user.firstName"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider :name="$t('form.fields.lastname')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.lastname') + ' *'"
                outlined
                v-model="user.lastName"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="2" class="hidden-md-and-down">
            <v-text-field outlined v-model="user.title" :label="$t('form.fields.title')"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.email')"
              v-slot="{ errors }"
              vid="originalEmail"
              rules="required|email|confirmed:@confirmationEmail"
            >
              <v-text-field
                ref="originalMail"
                v-model="user.email"
                :label="$t('form.fields.email') + ' *'"
                required
                outlined
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.confirmationEmail')"
              v-slot="{ errors }"
              vid="confirmationEmail"
              rules="required|email|confirmed:@originalEmail"
            >
              <v-text-field
                v-model="confirmationEmail"
                :label="$t('form.fields.confirmationEmail') + ' *'"
                required
                outlined
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <v-switch v-model="user.hasCompanyAddress" :label="$t('form.fields.companyAddress')"></v-switch>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2" v-if="user.hasCompanyAddress">
          <v-col>
            <validation-provider :name="$t('form.fields.company')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.company') + ' *'"
                outlined
                v-model="user.company"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field :label="$t('form.fields.department')" outlined v-model="user.department"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2" v-if="user.hasCompanyAddress">
          <v-col>
            <v-text-field
              :label="$t('form.fields.companyAddition')"
              outlined
              v-model="user.companyAddition"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <validation-provider :name="$t('form.fields.street')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.street') + ' *'"
                outlined
                v-model="user.street"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="2">
            <validation-provider :name="$t('form.fields.zip')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.zip') + ' *'"
                outlined
                v-model="user.zip"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="3">
            <validation-provider :name="$t('form.fields.city')" v-slot="{ errors }" rules="required">
              <v-text-field
                :label="$t('form.fields.city') + ' *'"
                outlined
                v-model="user.city"
                required
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <validation-provider :name="$t('form.fields.country')" v-slot="{ errors }" rules="required">
              <v-autocomplete
                :label="$t('form.fields.country') + ' *'"
                outlined
                :items="countries"
                item-text="value"
                item-value="key"
                :error-messages="errors"
                v-model="user.country"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field label="UID" outlined v-model="user.uid"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <v-text-field :label="$t('form.fields.phone')" outlined v-model="user.telephone" type="tel"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.mobilePhone')"
              outlined
              v-model="user.cellphone"
              type="tel"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <v-switch v-model="user.hasInvoiceAddress" :label="$t('form.fields.differentInvoiceAddress')"></v-switch>
          </v-col>
        </v-row>
        <v-expansion-panels
          :disabled="!user.hasInvoiceAddress"
          :value="user.hasInvoiceAddress ? 0 : null"
          class="mt-n8 mb-2"
          elevation="0"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("form.fields.invoiceAddress") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mb-2">
                <v-col cols="2" class="hidden-md-and-down">
                  <v-select
                    :label="$t('form.fields.salutation.label')"
                    outlined
                    v-model="user.invoiceSalutation"
                    :items="genderTypes"
                  ></v-select>
                </v-col>
                <v-col>
                  <validation-provider :name="$t('form.fields.firstname')" v-slot="{ errors }" rules="required">
                    <v-text-field
                      :label="$t('form.fields.firstname') + ' *'"
                      outlined
                      v-model="user.invoiceFirstName"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider :name="$t('form.fields.lastname')" v-slot="{ errors }" rules="required">
                    <v-text-field
                      :label="$t('form.fields.lastname') + ' *'"
                      outlined
                      v-model="user.invoiceLastName"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="2" class="hidden-md-and-down">
                  <v-text-field outlined v-model="user.invoiceTitle" :label="$t('form.fields.title')"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-n8 mb-2">
                <v-col>
                  <validation-provider :name="$t('form.fields.street')" v-slot="{ errors }" rules="required">
                    <v-text-field
                      :label="$t('form.fields.street') + ' *'"
                      outlined
                      v-model="user.invoiceStreet"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="2">
                  <validation-provider :name="$t('form.fields.zip')" v-slot="{ errors }" rules="required">
                    <v-text-field
                      :label="$t('form.fields.zip') + ' *'"
                      outlined
                      v-model="user.invoiceZip"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="3">
                  <validation-provider :name="$t('form.fields.city')" v-slot="{ errors }" rules="required">
                    <v-text-field
                      :label="$t('form.fields.city') + ' *'"
                      outlined
                      v-model="user.invoiceCity"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-n8 mb-2">
                  <validation-provider :name="$t('form.fields.country')" v-slot="{ errors }" rules="required">
                    <v-autocomplete
                      :label="$t('form.fields.country') + ' *'"
                      outlined
                      :items="countries"
                      item-text="value"
                      item-value="key"
                      :error-messages="errors"
                      v-model="user.invoiceCountry"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mt-8">
          <v-col class="publication-selection">
            <v-autocomplete
              @input="setPublicationIdToAdd"
              :value="publicationIdToAdd"
              :items="groupedPublications"
              outlined
              :label="$t('form.fields.publication')"
              item-text="title"
              item-value="id"
            >
              <template #selection="{item} ">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }} {{ item.author }} {{ item.author ? ", " : "" }} {{ item.publisher }}
                    <b>€ {{ item.price }}</b>
                    {{ item.vat ? $t("form.vatLabel", { vat: item.vat }) : "" }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-slot:item="{ item }">
                <template v-if="getType(item) !== 'object'">
                  <v-list-item-content v-text="item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="item.title"></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="
                        `${item.author ? item.author + ', ' + item.publisher : item.publisher} <b>€ ${item.price}</b> ${
                          item.vat ? $t('form.vatLabel', { vat: item.vat }) : ''
                        }`
                      "
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3" v-if="publicationToAdd && publicationToAdd.languages.length > 0">
            <v-autocomplete
              :value="languageIdToAdd"
              @input="setLanguageIdToAdd"
              :items="publicationToAdd.languages"
              outlined
              :label="$t('form.fields.language')"
              item-text="title"
              width="200"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>
          <v-btn
            tile
            large
            color="primary"
            icon
            @click="addToCart(publicationIdToAdd, languageIdToAdd)"
            class="mt-4"
            :disabled="!allowAddToCart"
          >
            <v-icon large>mdi-plus-box</v-icon>
          </v-btn>
        </v-row>

        <v-row>
          <v-col class="mt-n8">
            <v-list v-for="(cartData, index) in cart" :key="cartData.internalId" color="transparent">
              <v-list-item class="mt-n4 mb-n4">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ cartData.title }}
                    <span v-if="cartData.language">
                      <b>{{ cartData.language.title }}</b>
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-html="
                      `${cartData.publisher} <b>€ ${cartData.price}</b> ${
                        cartData.vat ? $t('form.vatLabel', { vat: cartData.vat }) : ''
                      }`
                    "
                  >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-row>
                    <v-col>
                      <v-input>
                        <template v-slot:prepend>
                          <v-btn tile large color="primary" icon @click="decreaseCartAmount(index)">
                            <v-icon large>mdi-minus-box</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:default>
                          <p class="title mt-2 ml-n1 mr-n1">
                            {{ cartData.amount }}
                          </p>
                        </template>
                        <template v-slot:append>
                          <v-btn tile large color="primary" icon @click="++cartData.amount">
                            <v-icon large>mdi-plus-box</v-icon>
                          </v-btn>
                        </template>
                      </v-input>
                    </v-col>
                    <v-col>
                      <p class="headline font-weight-bold mt-2">€ {{ cartData.amount * cartData.price }}</p>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="index === cart.length - 1">
                <v-list-item-content> </v-list-item-content>
                <v-list-item-action>
                  <p class="headline font-weight-bold mt-2">€ {{ cartSum }}</p>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-expand-transition>
          <v-row v-show="!paymentStep">
            <v-spacer />
            <v-col cols="auto">
              <v-btn @click="paymentStep = true" color="primary" :disabled="invalid || cart.length === 0">
                {{ $t("form.btn.payment") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-expand-transition>
          <payment-form
            v-show="paymentStep"
            @onContinue="
              paymentStep = false;
              dialog = true;
              clearOrder();
            "
          />
        </v-expand-transition>
      </validation-observer>
    </v-form>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="white--text headline primary" primary-title>
          {{ $t("form.confirmationDialog.title") }}
        </v-card-title>

        <v-card-text class="pa-md-4">
          {{ $t("form.confirmationDialog.confirmationText") }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              dialog = false;
              $vuetify.goTo(0);
            "
          >
            {{ $t("form.confirmationDialog.buttonText") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { GenderTypes } from "../config/constants";
import PaymentForm from "./PaymentForm.vue";
import de from "../i18n/de.json";

export default {
  components: { PaymentForm },
  data: () => ({
    confirmationEmail: null,
    dialog: false,
    paymentStep: false,
  }),
  methods: {
    ...mapActions(["submitReservation", "clearOrder", "addToCart", "decreaseCartAmount", "clearOrder"]),
    ...mapMutations(["setPublicationIdToAdd", "setLanguageIdToAdd"]),

    addPublication(e) {
      this.setPublicationIdToAdd(e.target.dataset.value);
      this.setLanguageIdToAdd(null);
    },

    getType(obj) {
      return typeof obj;
    },
  },
  computed: {
    ...mapGetters(["categories", "groupedPublications", "cartSum", "publicationToAdd", "allowAddToCart"]),
    ...mapState(["cart", "user", "publicationIdToAdd", "languageIdToAdd"]),
    genderTypes() {
      return GenderTypes.map((t) => {
        return { value: t, text: this.$t(`form.fields.salutation.${t}`) };
      });
    },

    countries() {
      return Object.keys(de.countries).map((countryKey) => {
        return {
          key: countryKey,
          value: this.$t(`countries.${countryKey}`),
        };
      });
    },
  },
  created: function() {
    const selectButtons = document.getElementsByClassName("publication-select");
    for (let i = 0; i < selectButtons.length; i++) {
      selectButtons[i].addEventListener("click", this.addPublication);
    }
  },
  destroyed: function() {
    const selectButtons = document.getElementsByClassName("publication-select");
    for (let i = 0; i < selectButtons.length; i++) {
      selectButtons[i].removeEventListener("click", this.addPublication);
    }
  },
};
</script>
